import React, {useContext} from 'react'
import {
  Route,
  Redirect
} from 'react-router-dom'
import {AuthContext} from "providers/Auth/AuthProvider.jsx";


const PrivateRoute = ({ component: Component, ...rest }) => {
    const authManager = useContext(AuthContext);

    return (
        <Route {...rest} 
            render={(props) => {
                let route =  (<Component {...props} />);
                const loggedIn = (authManager && authManager.auth && authManager.auth.user);
        
                //If not logged in, and not on login already, redirect to login
                if(!loggedIn && props.location.pathname != '/login'){
                    route = (<Redirect to={{
                        pathname: '/login',
                        state: { from: props.location }
                    }} />)
                }             
                
                //If logged in, but on login already, redirect to dashboard
                 if( loggedIn && props.location.pathname === '/login'){
                    route = (<Redirect to={{
                        pathname: '/dashboard',
                        state: { from: props.location }
                    }} />)
                }  

                return(
                    route
                ) 
            } 
        }/>
    )
}

  export default PrivateRoute


// WEBPACK FOOTER //
// ./src/components/PrivateRoute/PrivateRoute.jsx